<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-tabView (onChange)="cambioTabSeleccionado($event)">
    <p-tabPanel header="{{ 'PRODUCTO.LBL_PRODUCTO' | translate}}" >
       <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event.index)">
          <p-accordionTab header="{{ 'PRODUCTO.LBL_IDENTIFICACIONPRODUCTO' | translate }}"
                          [selected]="tabSeleccionado === 'PRODUCTO'">
            <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
              <div class="grid form-group">
                <div class="col-12 md:col-4 lg:col-4">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_CODIGO' | translate }}</label>
                    <div *ngIf="!producto">
                      <input type="text" pInputText id="codigo"
                             name="nomCodigo"
                             autocomplete="off"
                             formControlName="codigo"
                             maxlength="10"
                             (blur)="validarCodigo()"
                             codigos-reactive
                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                        {{ 'PRODUCTO.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                        {{ 'MSG_CODIGOEXISTE' | translate}}
                      </div>
                    </div>
                    <div *ngIf="producto && producto.idProducto">
                      <label class="falso-combo-texto">{{producto.codigo}}</label>
                    </div>
                  </div>
                </div>

                <div class="col-12 md:col-4 lg:col-4" *ngIf="codeTipoProductoBancario === codigosProducto.INVERSION">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_TIPO_PRODUCTO' | translate }}</label>
                    <div *ngIf="!producto?.idTiposTitulosInversiones">
                      <p-dropdown disableTab
                                  id="idTiposTitulosInversiones"
                                  name="idTiposTitulosInversiones"
                                  placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                  formControlName="idTiposTitulosInversiones"
                                  [options]="listaTipoTituloInversion"
                                  emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                  emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                  optionValue="value"
                                  optionLabel="label"
                      ></p-dropdown>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTiposTitulosInversiones.invalid">
                        {{ 'PRODUCTO.LBL_TIPO_PRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                    <div *ngIf="producto?.idTiposTitulosInversiones">
                      <label class="falso-combo-texto">{{ producto.tiposTitulosInversion }}</label>
                    </div>
                  </div>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_NOMBREPRODUCTO' | translate }}</label>
                    <input type="text" pInputText id="nombre"
                           name="nomNombre"
                           autocomplete="off"
                           formControlName="nombre"
                           [maxlength]="100"
                           capitalize-reactive
                    >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                      {{ 'PRODUCTO.LBL_NOMBREPRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>

                <div class="col-12 md:col-4 lg:col-4" *ngIf="codeTipoProductoBancario === codigosProducto.AHORRO">
                  <div class="div-form">
                    <label for="idModalidad">* {{ 'PRODUCTO.LBL_TIPOPRODUCTO_CUENTA' | translate }}</label>
                    <p-dropdown id="idTipoCuenta" name="nomModalidad" [options]="listaTipoCuenta"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                [autoWidth]="false" formControlName="idTipoCuenta"
                    ></p-dropdown>

                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoCuenta.invalid">
                      {{ 'PRODUCTO.LBL_TIPOPRODUCTO_CUENTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>


                <div class="col-12 md:col-4 lg:col-4" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                  <div class="div-form">
                    <label for="idModalidad">* {{ 'PRODUCTO.LBL_MODALIDAD' | translate }}</label>
                    <p-dropdown disableTab  id="idModalidad" name="nomModalidad" [options]="lisModalidades"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idModalidad"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idModalidad.invalid">
                      {{ 'PRODUCTO.LBL_MODALIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="codeTipoProductoBancario != codigosProducto.PASARELA">
              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12" style="margin-left: 7px">
                  <strong>{{ 'PRODUCTO.LBL_COMERCIALIZACION' | translate }}</strong>
                </div>
              </div>
              <div class="grid form-group">
                <ng-container *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                  <div class="col-12 md:col-3 lg:col-3">
                    <div class="div-form">
                      <p-checkbox label="{{ 'PRODUCTO.LBL_ALIADOS' | translate}}" binary="true"
                                  id="indicadorAliados"
                                  name="nomIndicadorAliados"
                                  formControlName="indicadorComercializacionAliados"></p-checkbox>
                      <br>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && relIndicadorAliadoOficina">
                        {{ 'PRODUCTO.LBL_ALIADOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-3 lg:col-3">
                    <div class="div-form">
                      <p-checkbox label="{{ 'PRODUCTO.LBL_OFICINAS' | translate}}" binary="true"
                                  id="indicadorOficinas"
                                  name="nomIndicadorOficinas"
                                  formControlName="indicadorComercializacionOficinas"></p-checkbox>
                      <br>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && relIndicadorAliadoOficina">
                        {{ 'PRODUCTO.LBL_OFICINAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-3 lg:col-3">
                    <div class="div-form">
                      <p-checkbox label="{{ 'PRODUCTO.LBL_ESPECIAL' | translate}}" binary="true"
                                  id="indicadorEspecial"
                                  name="nomIndicadorEspecial"
                                  formControlName="indicadorEspecial"></p-checkbox>


                    </div>
                  </div>
                </ng-container>

                <div class="col-12 md:col-3 lg:col-3" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                  <div class="div-form">
                    <p-checkbox label="{{ 'PRODUCTO.LBL_LIBRANZA' | translate}}" binary="true"
                                id="indicadorLibranza"
                                name="nomIndicadorLibranza"
                                formControlName="indicadorLibranza"
                                (click)="validarIndRotativoLibranza('indicadorLibranza',f.indicadorRotativo.value)"></p-checkbox>
                  </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3" *ngIf="codeTipoProductoBancario != codigosProducto.AHORRO">
                  <div class="div-form">
                    <p-checkbox label="{{ 'PRODUCTO.LBL_ROTATIVO' | translate}}" binary="true"
                                id="indicadorRotativo"
                                name="nomIndicadorRotativo"
                                formControlName="indicadorRotativo"
                                (click)="validarIndRotativoLibranza('indicadorRotativo',f.indicadorRotativo.value)"></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-12 lg:col-12" style="margin-left: 7px" >
                  <strong>{{ 'PRODUCTO.LBL_FUERZACOMERCIAL' | translate }}</strong>
                </div>
              </div>
              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox label="{{ 'PRODUCTO.LBL_EJECUTIVO' | translate}}" binary="true"
                                id="indicadorEjecutivo"
                                name="nomIndicadorEjecutivo"
                                formControlName="indicadorEjecutivo"></p-checkbox>
                  </div>
                </div>


                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox label="{{ 'PRODUCTO.LBL_FREELANCE' | translate}}" binary="true"
                                id="indicadorFreelance"
                                name="nomIndicadorFreelance"
                                formControlName="indicadorFreelance"></p-checkbox>
                  </div>
                </div>
              </div>

              <div class="grid form-group">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_FECHAINICIAL' | translate }}</label>
                    <p-calendar id="idFechaInicial" [showButtonBar]="true" name="nomFechaInicial" [showIcon]="true" [showTime]="false"
                                [monthNavigator]="true" [yearNavigator]="true" yearRange="{{calPropiedades.rango}}"
                                [locale]="calPropiedades.informacion" readonlyInput="true" [maxDate]="maxFechaInicial"
                                formControlName="fechaInicioVigencia"
                                dataType="date" (onSelect)="seleccionarFechaInicial($event)"
                                dateFormat="yy'-'mm'-'dd">
                    </p-calendar>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaInicioVigencia.invalid">
                      {{ 'PRODUCTO.LBL_FECHAINICIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_FECHAFINAL' | translate }}</label>
                    <p-calendar id="idFechaFinal" [showButtonBar]="true" name="nomFechaFinal" [showIcon]="true" [showTime]="false"
                                [monthNavigator]="true" [yearNavigator]="true" yearRange="{{calPropiedades.rango}}"
                                [locale]="calPropiedades.informacion" readonlyInput="true" [minDate]="minFechaFinal"
                                formControlName="fechaFinVigencia"
                                dataType="date" (onSelect)="seleccionarFechaFinal($event)"
                                dateFormat="yy'-'mm'-'dd">
                    </p-calendar>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaFinVigencia.invalid">
                      {{ 'PRODUCTO.LBL_FECHAFINAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_TIPOCUPO' | translate }}</label>
                    <p-dropdown disableTab  id="idTipoCupo" name="nomTipoCupo" [options]="lisCupos"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idTipoCupoProducto"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoCupoProducto.invalid">
                      {{ 'PRODUCTO.LBL_TIPOCUPO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_CLASIFICACIONPRODUCTO' | translate }}</label>
                    <p-dropdown disableTab  id="idClasificacion" name="nomClasificacion" [options]="lisClasificaciones"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idClasificacionProducto"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idClasificacionProducto.invalid">
                      {{ 'PRODUCTO.LBL_CLASIFICACIONPRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_ACTAJUNTA' | translate }}</label>
                    <input type="text" pInputText id="idActaJunta"
                           name="nomActaJunta"
                           autocomplete="off"
                           formControlName="codigoActaAprobacion"
                           [maxlength]="20"
                    >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoActaAprobacion.invalid">
                      {{ 'PRODUCTO.LBL_ACTAJUNTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_FECHAAPROBACIONACTA' | translate }}</label>
                    <p-calendar id="idFechaActa" [showButtonBar]="true" name="nomFechaActa" [showIcon]="true" [showTime]="false"
                                [monthNavigator]="true" [yearNavigator]="true" yearRange="{{calPropiedades.rango}}"
                                [locale]="calPropiedades.informacion" readonlyInput="true"
                                formControlName="fechaAprobacionActa"
                                dataType="date"
                                dateFormat="yy'-'mm'-'dd">
                    </p-calendar>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaAprobacionActa.invalid">
                      {{ 'PRODUCTO.LBL_FECHAAPROBACIONACTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid form-group" *ngIf="codeTipoProductoBancario != codigosProducto.AHORRO">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_MONTOMINIMO' | translate }} ({{ 'LBL_SMLV' | translate }})</label>
                    <input type="text" pInputText id="idMontoMinimo"
                           name="nomMontoMinimo"
                           autocomplete="off" [entero]="7"
                           formControlName="montoMinimo" numero-decimal-reactive [decimales]="6" [minimo]="0"
                           [maxlength]="14">
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMinimo.invalid">
                      {{ 'PRODUCTO.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
                      {{ 'LBL_RANGOINVALIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_MONTOMAXIMO' | translate }} ({{ 'LBL_SMLV' | translate }})</label>
                    <input type="text" pInputText id="idMontoMaximo"
                           name="nomMontoMaximo"
                           autocomplete="off"
                           formControlName="montoMaximo" numero-decimal-reactive [decimales]="6" [minimo]="0" [entero]="7"
                           [maxlength]="14">
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximo.invalid">
                      {{ 'PRODUCTO.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
                      {{ 'LBL_RANGOINVALIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid form-group" *ngIf="codeTipoProductoBancario != codigosProducto.AHORRO">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_PLAZOMINIMO' | translate }} ({{ 'LBL_MESES' | translate }})</label>
                    <input type="text" pInputText id="idPlazoMinimo"
                           name="nomPlazoMinimo"
                           autocomplete="off"
                           formControlName="plazoMinimo"
                           [maxlength]="3"
                           numero-entero-reactive>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMinimo.invalid">
                      {{ 'PRODUCTO.LBL_PLAZOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="plaIncorrecto">
                      {{ 'LBL_RANGOINVALIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_PLAZOMAXIMO' | translate }} ({{ 'LBL_MESES' | translate }})</label>
                    <input type="text" pInputText id="idPlazoMaximo"
                           name="nomPlazoMaximo"
                           autocomplete="off"
                           formControlName="plazoMaximo"
                           [maxlength]="3"
                           numero-entero-reactive>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMaximo.invalid">
                      {{ 'PRODUCTO.LBL_PLAZOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="plaIncorrecto">
                      {{ 'LBL_RANGOINVALIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <p-fieldset legend="{{ 'PRODUCTO.LBL_FRECVARI' | translate }}" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="grid col-12 form-group">
                  <div class="col-12 md:col-12 lg:col-12">
                    <div class="grid">
                      <div class="col-12 md:col-6 lg:col-6">
                        <div class="div-form">
                          <label>{{ 'PRODUCTO.LBL_PLAZOMINIMOMES' | translate }}</label>
                          <input type="text" pInputText id="plazoMinimoFrecuencia"
                                 name="nomPlazoMinimoFrecuencia" maxlength="5" (blur)="ValidarPlazo()"
                                 autocomplete="off" numero-entero-reactive [maxlength]="4"
                                 formControlName="plazoMinimoFrecuencia">
                          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMinimoFrecuencia.invalid">
                            {{ 'PRODUCTO.LBL_PLAZOMINIMOMES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 md:col-6 lg:col-6">
                        <div class="div-form">
                          <label>{{ 'PRODUCTO.LBL_PLAZOMAXIMOMES' | translate }}</label>
                          <input type="text" pInputText id="plazoMaximoFrecuencia" [minimo]="1"
                                 name="nomPlazoMaximoFrecuencia" maxlength="5" (blur)="ValidarPlazo()"
                                 autocomplete="off" numero-entero-reactive [maxlength]="4"
                                 formControlName="plazoMaximoFrecuencia">
                          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMaximoFrecuencia.invalid">
                            {{ 'PRODUCTO.LBL_PLAZOMAXIMOMES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </p-fieldset>
              <p-fieldset class="overflow-y-unset" legend="{{ 'PRODUCTO.LBL_ADMTASAS' | translate }}" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO" >
              <div class="grid col-12 form-group flex align-items-center">
                <div class="col-12 md:col-4 lg:col-2">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_MANEJATASA' | translate}}" binary="true"
                              id="idManejaTasa"
                              name="nomManejaTasa" (onChange)="cambioManejaTasa($event.checked)"
                              formControlName="indicadorManejaTasa"></p-checkbox>
                </div>

                <!-- Tasa -->
                <div class="col-12 md:col-6 lg:col-5" *ngIf="f.indicadorManejaTasa.value">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_TASA' | translate }} (%)</label>
                    <input type="text" pInputText id="idTasa"
                           name="nomTasa"
                           autocomplete="off"
                           formControlName="tasa"
                           [maxlength]="9"
                           porcentaje-reactive [decimales]="6">
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tasa.invalid">
                      {{ 'PRODUCTO.LBL_TASA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div [ngClass]="{
                  'col-12 md:col-2 lg:col-2': habilitarTasaVariable,
                  'col-12 md:col-6 lg:col-5': !habilitarTasaVariable }" *ngIf="!f.indicadorManejaTasa.value">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_TASA' | translate }} (%)</label>
                    <p-multiSelect id="idTipoTasas" name="nomTasas" [options]="listaTiposTasasProducto" filter="filter"
                                   placeholder="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="activarTasaVariable($event)"
                                   selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idTipoTasas"
                                   emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionValue="value"
                                   optionLabel="label"
                    ></p-multiSelect>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoTasas.invalid">
                      {{ 'PRODUCTO.LBL_TASA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-4 lg:col-3" *ngIf="habilitarTasaVariable">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_TASAVARIABLE' | translate }}</label>
                    <p-dropdown disableTab  id="idTasaVariable" name="nomIdTasaVariable" [options]="listaTasasVariables"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idTasaVariable"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTasaVariable.invalid">
                      {{ 'PRODUCTO.LBL_TASAVARIABLE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-2 lg:col-2" *ngIf="habilitarTasaVariable">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_PUNTOTASA' | translate }}</label>
                    <input type="text" pInputText id="puntosTasaVariable"
                           name="puntosTasaVariable"
                           autocomplete="off"
                           formControlName="puntosTasaVariable" porcentaje-reactive
                           [maxlength]="10" [maximo]="999" [decimales]="6">
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.puntosTasaVariable.invalid">
                      {{ 'PRODUCTO.LBL_PUNTOTASA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <!-- No aplica descuerdo por perfil de riesgo -->
                <div [ngClass]="{ 'col-12 md:col-4 lg:col-3': habilitarTasaVariable,
                                'col-12 md:col-4 lg:col-3 lg:col-offset-2': !habilitarTasaVariable }">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_NOAPLICADESCPORPERFILRIESGO' | translate}}" binary="true"
                              id="idIndicadorNoAplicaDescuentoPerfilRiesgo"
                              name="nomIndicadorNoAplicaDescuentoPerfilRiesgo"
                              formControlName="indicadorNoAplicaDescuentoPerfilRiesgo"></p-checkbox>
                </div>
                <!-- Tasa Máxima Especial -->
                <div class="col-12 md:col-4 lg:col-2">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_MANEJADCTOTASA' | translate}}" binary="true"
                              id="idIndicadorManejaDctoTasa"
                              name="nomIndicadorManejaDctoTasa"
                              formControlName="indicadorManejaDctoTasa"></p-checkbox>
                </div>
                <div class="col-12 md:col-4 lg:col-4" *ngIf="f.indicadorManejaDctoTasa.value">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_SOLICITUDTASAESPECIAL' | translate }}</label>
                    <p-dropdown disableTab  id="idSolicitudTasaEspecial" name="nomSolicitudTasaEspecial"
                                [options]="listasSolicitudesTasasEspeciales" formControlName="idSolicitudTasaEspecial"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                                placeholder="{{'LBL_SELECCIONE' | translate}}"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.idSolicitudTasaEspecial.value">
                      {{ 'PRODUCTO.LBL_SOLICITUDTASAESPECIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-4 lg:col-4" *ngIf="f.indicadorManejaDctoTasa.value">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_TASAMAXIMAESPECIAL' | translate }} (%)</label>
                    <input type="text" pInputText id="tasaMaximaEspecial"
                           name="nomTasaMaximaEspecial"
                           autocomplete="off"
                           formControlName="tasaMaximaEspecial"
                           [maxlength]="5"
                           porcentaje-reactive [decimales]="2">
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.tasaMaximaEspecial.value">
                      {{ 'PRODUCTO.LBL_TASAMAXIMAESPECIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              </p-fieldset >
              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-6 lg:col-6">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_DUPLICARDIRECCION' | translate}}" binary="true"
                              id="idDuplicarDireccion"
                              name="nomDuplicarDireccion"
                              formControlName="indicadorDuplicarDireccionNegocio"></p-checkbox>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <label>* {{ 'PRODUCTO.LBL_ICONO' | translate }}</label>
                  <p-dropdown disableTab  id="idIcono" name="nomIcono" [options]="lisFuentes"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              filter="true"
                               formControlName="icono"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label">
                    <ng-template let-dat pTemplate="selectedItem">
                      <div class="p-helper-clearfix" style="position: relative;height: auto;">
                        <i class="{{dat && dat?.label ? dat?.label : null}}"></i>
                        <span style="vertical-align:middle;">{{dat && dat?.label ? dat?.label : null}}</span>
                      </div>
                    </ng-template>
                    <ng-template let-dat pTemplate="item">
                      <div class="p-helper-clearfix" style="position: relative;height: 25px;">
                        <i class="{{dat && dat?.label ? dat?.label : null}} fa-2x"></i>
                        <span style="vertical-align:middle; margin-left: .5em">{{dat && dat?.label ? dat?.label : null}}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.icono.invalid">
                    {{ 'PRODUCTO.LBL_ICONO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>


              </div>
              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-6 lg:col-6">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_APROBPLANPAGO' | translate}}" binary="true"
                              id="indicadorAprobacionPlanPago"
                              name="indicadorAprobacionPlanPago"
                              formControlName="indicadorAprobacionPlanPago"></p-checkbox>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'VISITA.LBL_AMORTIZACION' | translate }}</label>
                    <p-dropdown disableTab  id="idAmortizacion" name="nomAmortizacion" [options]="listaTiposCuotas"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idTipoAmortizacion"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoAmortizacion.invalid">
                      {{ 'VISITA.LBL_AMORTIZACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-6 lg:col-6">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_NOREQUIEREUNIDADCREDITO' | translate}}" binary="true"
                              id="idIndicadorNoRequiereUnidad"
                              name="nomIndicadorNoRequiere"
                              formControlName="indicadorNoRequiereUnidadCredito"></p-checkbox>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_APLICAGARANTIAIDONEA' | translate}}" binary="true"
                              id="indicadorAplicaGarantiaIdonea"
                              name="indicadorAplicaGarantiaIdonea"
                              formControlName="indicadorAplicaGarantiaIdonea"></p-checkbox>
                </div>
              </div>
              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-6 lg:col-6">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_RECOGECREDITO' | translate}}" binary="true"
                              (click)="recogerCartera()"
                              id="indicadorRecogeCredito"
                              name="indicadorRecogeCredito"
                              formControlName="indicadorRecogeCredito"></p-checkbox>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form" *ngIf="this.f.indicadorRecogeCredito.value">
                    <label>* {{ 'PRODUCTO.LBL_TIPOCARTERA' | translate }}</label>
                    <p-dropdown disableTab  id="idTipoCartera" name="tipoCartera" [options]="listaTipoCartera"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idTipoCartera"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoCartera.invalid">
                      {{ 'PRODUCTO.LBL_TIPOCARTERA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="col-12 md:col-6 lg:col-6">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_SEGUROSVOLUNTARIOSPREAPROBADOS' | translate}}" binary="true"
                              id="idIndicadorSeguroVoluntarioPreaprobado"
                              name="nomIndicadorSeguroVoluntarioPreaprobado"
                              formControlName="indicadorSeguroVoluntarioPreaprobado"></p-checkbox>
                </div>
              </div>


              <p-fieldset legend="{{ 'PRODUCTO.LBL_RANGOPAGO' | translate }}" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
                <div class="grid col-12 form-group" *ngIf="f.indicadorComercializacionOficinas.value">
                  <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                      <label>{{ 'PRODUCTO.LBL_DIAPRIMERPAGODE' | translate }}</label>
                      <input type="text" pInputText id="idPrimerPago"
                             name="nomPrimerPago"
                             autocomplete="off"
                             formControlName="diaDePrimerPago"
                             [maxlength]="2" [maximo]="30" [minimo]="1"
                             numero-entero-reactive (blur)="validarRangoPrimerPago()">
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diaDePrimerPago.invalid">
                        {{ 'PRODUCTO.LBL_DIAPRIMERPAGODE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="ranPrimerPagoIncorrecto">
                        {{ 'LBL_RANGOINVALIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                      <label>{{ 'PRODUCTO.LBL_DIAPRIMERPAGOHASTA' | translate }}</label>
                      <input type="text" pInputText id="primerPagoHasta"
                             name="nomPrimerPagoHasta"
                             autocomplete="off"
                             formControlName="diaHastaPrimerPago"
                             [maxlength]="2" [maximo]="30" [minimo]="1"
                             numero-entero-reactive (blur)="validarRangoPrimerPago()">
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diaHastaPrimerPago.invalid">
                        {{ 'PRODUCTO.LBL_DIAPRIMERPAGOHASTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="ranPrimerPagoIncorrecto">
                        {{ 'LBL_RANGOINVALIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </p-fieldset>

              <div class="grid form-group" *ngIf="codeTipoProductoBancario == codigosProducto.INVERSION">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_TIPO_INTERESES' | translate }}</label>
                    <p-multiSelect id="idsTiposIntereses"
                                   name="idsTiposIntereses"
                                   formControlName="idsTiposIntereses"
                                   [options]="listaTipoInteres"
                                   [filter]="true"
                                   [placeholder]="'LBL_SELECCIONE' | translate"
                                   selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                                   emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionValue="value"
                                   optionLabel="label"
                    ></p-multiSelect>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsTiposIntereses.invalid">
                      {{ 'PRODUCTO.LBL_TIPO_INTERESES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>

                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_CANAL_CDT' | translate }}</label>
                    <p-dropdown disableTab
                                id="idCanalInversiones"
                                name="idCanalInversiones"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                formControlName="idCanalInversiones"
                                [options]="listaCanalesCDTS"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCanalInversiones.invalid">
                      {{ 'PRODUCTO.LBL_CANAL_CDT' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid form-group">
                <div class="col-12 md:col-12 lg:col-12">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_DESCRIPCION' | translate }}</label>
                    <textarea id="idDescripcion" name="nomDescripcion" pInputTextarea rows="2"
                              capitalize-reactive maxlength="500"
                              formControlName="descripcion"></textarea>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                      {{ 'PRODUCTO.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-6 md:col-6" *ngIf="codeTipoProductoBancario != codigosProducto.AHORRO && (producto && producto.indicadorFlujoDigital == true)">
                  <div class="div-form">
                    <div *ngIf="((producto.idAdjuntoIcono != null))" class="btn-group" role="group" style="display: block;">
                      <a class="btn btn-default" style="max-width: 87%; overflow: hidden; display: grid; cursor: default">
                        <i class="fa fa-file-o" *ngIf="((producto.idAdjuntoIcono != null && !imagen))"  aria-hidden="true"></i>
                        <img *ngIf="imagen" style="height: 100px" [src]="imagen" alt=""/>
                        <div>
                          <a class="btn btn-danger" style="cursor: default; margin-right: 7px;" *ngIf="((producto.idAdjuntoIcono != null))" (click)="uploadAgain(false)">
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </a>
                          <small style="color: #606060">{{producto.nombreAdjuntoIcono}}</small>
                        </div>
                      </a>
                    </div>
                    <p-fileUpload [hidden]="producto.idAdjuntoIcono" name="file" url="{{svcThUrl}}" [auto]="false" class="upload-avatar"
                                  chooseLabel="{{'LBL_ADJUNTAR' | translate}}" #adjunto
                                  (onBeforeUpload)="onBeforeSend($event)"
                                  (onValidSelect)="onSelect($event, $event.files)"
                                  (onUpload)="uploadingOk($event)"
                                  invalidFileTypeMessageSummary="{0} {{'LBL_FILETIPO' | translate}}."
                                  invalidFileTypeMessageDetail="{{'PRODUCTO.LBL_FILETIPOES' | translate}}"
                                  mode="basic" fSize [accept]="ftype">
                    </p-fileUpload>
                    <div *ngIf="((producto.idAdjuntoIcono == null))">
                      {{ 'LBL_TAMANOMAXIMO' | translate}}: {{fsize / 1000000}} MB <br>
                      {{ 'LBL_TIPOARCHIVO' | translate}}: {{'PRODUCTO.FTYPE' | translate }}
                    </div>
                  </div>

                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'PRODUCTO.LBL_RESENA' | translate }}</label>
                    <input type="text" pInputText id="resena"
                           name="resenaDigital"
                           autocomplete="off"
                           formControlName="resenaDigital"
                           appTexto [sinPunto]="false" [sinCaracteres]="true" [sinComa]="false"
                           maxlength="70">
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.resenaDigital.invalid">
                      {{ 'PRODUCTO.LBL_RESENA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>


              <div class="grid form-group" *ngIf="codeTipoProductoBancario != codigosProducto.CREDITO">
                <ng-container *ngIf="codeTipoProductoBancario == codigosProducto.AHORRO">
                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>* {{ 'PRODUCTO.LBL_TIPOPRODUCTO_MEDIOS' | translate }} (%)</label>
                      <p-multiSelect id="idMedioAsociado" name="nomTasas" [options]="listaTiposMediosAsociados" filter="filter"
                                     defaultLabel="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="activarTasaVariable($event)"
                                     selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idMedioAsociado"
                                     emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                     emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                     optionValue="value"
                                     optionLabel="label"
                      ></p-multiSelect>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idMedioAsociado.invalid">
                        {{ 'PRODUCTO.LBL_TIPOPRODUCTO_MEDIOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>

                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>* {{ 'PRODUCTO.LBL_TIPOPRODUCTO_SOLICITUD_LLAVES' | translate }} (%)</label>
                      <p-multiSelect id="idTiposSolicitudesLlaves" name="nomTasas" [options]="listaTiposSolicitudesLlaves" filter="filter"
                                     defaultLabel="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="activarTasaVariable($event)"
                                     selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idTiposSolicitudesLlaves"
                                     emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                     emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                     optionValue="value"
                                     optionLabel="label"
                      ></p-multiSelect>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idMedioAsociado.invalid">
                        {{ 'PRODUCTO.LBL_TIPOPRODUCTO_SOLICITUD_LLAVES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>

                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>* {{ 'PRODUCTO.LBL_TIPOPRODUCTO_RENTABILIDAD' | translate }}</label>
                      <input type="text" pInputText id="rentabilidad"
                             name="nomNombre"
                             autocomplete="off"
                             formControlName="rentabilidad"
                             numero-decimal-reactive [decimales]="6" [entero]="3"
                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rentabilidad.invalid">
                        {{ 'PRODUCTO.LBL_TIPOPRODUCTO_RENTABILIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </ng-container>


                <div class="col-12 md:col-4 lg:col-4" *ngIf="codeTipoProductoBancario != codigosProducto.CREDITO">
                  <div class="div-form">
                    <p-checkbox label="{{ 'PRODUCTO.LBL_TIPOPRODUCTO_IMPUESTO_FINANCIERO' | translate}}" binary="true"
                                id="impuestoFinanciero"
                                name="nomIndicadorLibranza"
                                formControlName="impuestoFinanciero"></p-checkbox>
                  </div>
                </div>

                <div class="col-12 md:col-4 lg:col-4" *ngIf="codeTipoProductoBancario == codigosProducto.INVERSION">
                  <div class="div-form">
                    <p-checkbox label="{{ 'PRODUCTO.LBL_RENOVACIÓN_AUTO' | translate}}" binary="true"
                                id="indicadorAplicaRenovacionAutomatica"
                                name="indicadorAplicaRenovacionAutomatica"
                                formControlName="indicadorAplicaRenovacionAutomatica"></p-checkbox>
                  </div>
                </div>

                <div class="col-12 md:col-4 lg:col-4"
                     *ngIf="codeTipoProductoBancario == codigosProducto.INVERSION ||
                            (codeTipoProductoBancario == codigosProducto.AHORRO && codeTipoCuentaAhorro == tiposCuentaAhorro.AHORRO_PROGRAMADO)">
                  <div class="div-form">
                    <p-checkbox label="{{ 'PRODUCTO.LBL_INDICADOR_BTN_PSE' | translate}}"
                                [binary]="true"
                                id="indicadorBotonPse"
                                name="indicadorBotonPse"
                                formControlName="indicadorBotonPse">
                    </p-checkbox>
                  </div>
                </div>


              </div>
              </ng-container>

              <div class="grid form-footer-buttons">
                <div class="form-group col-12">
                  <div *ngIf="!guardando">
                    <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                    <button icon="fa fa-plus" label="{{( f.idProducto.value ? 'BTN_ACTUALIZAR' : 'BTN_GUARDAR')  | translate }}"
                            type="submit"
                            pButton></button>
                  </div>
                  <div *ngIf="guardando">
                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                    <span>{{'LBL_GUARDANDO' | translate }}</span>
                  </div>
                </div>
              </div>
            </form>
          </p-accordionTab>
          <p-accordionTab header="{{ 'PRODUCTO.LBL_SECCIONESPROCTO' | translate }}"
                          [selected]="tabSeleccionado === 'INDICADORES'" [disabled]="!producto">
            <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="FormularioIndicadores" name="nomFormularioIndicadores">
              <div class="grid form-group">
                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_ALERTAS' | translate}}" binary="true"
                              id="indicadorAlertas"
                              name="nomIndicadorAlertas"
                              formControlName="indicadorAlertas"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_CONFIRVINCU' | translate}}" binary="true"
                              id="indicadorConfirmacionVinculacion"
                              name="nomIndicadorConfirmacionVinculacion"
                              formControlName="indicadorConfirmacionVinculacion"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_CUESTIONARIOS' | translate}}" binary="true"
                              id="indicadorCuestionario"
                              name="nomIndicadorCuestionario"
                              formControlName="indicadorCuestionario"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_DESEMBOLSO' | translate}}" binary="true"
                              id="indicadorDesembolso"
                              name="nomIndicadorDesembolso"
                              formControlName="indicadorDesembolso"></p-checkbox>
                </div>
                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_HOJAEVALUACION' | translate}}" binary="true"
                              id="indicadorHojaEvaluacion"
                              name="indicadorHojaEvaluacion"
                              formControlName="indicadorHojaEvaluacion"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4" *ngIf="f.indicadorHojaEvaluacion.value">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_FLUJOCAJA' | translate}}" binary="true"
                              id="indicadorFlujoCaja"
                              name="indicadorFlujoCaja"
                              formControlName="indicadorFlujoCaja"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_MONTOPORDESTINO' | translate}}" binary="true"
                              id="idMontoPorDestino"
                              name="nomMontoPorDestino"
                              formControlName="indicadorMontoDestino"  (onChange)="validarMontos($event, 'Monto')"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_MONTOSPERFIL' | translate}}" binary="true"
                              id="indicadorMontoDestinoPerfil"
                              name="nomIMontoDestinoPerfil"
                              formControlName="indicadorMontoDestinoPerfil" (onChange)="validarMontos($event, 'Perfil')"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_PUEDERENOVAR' | translate}}" binary="true"
                              id="idIndicadorRenovable"
                              name="nomIndicadorRenovable"
                              formControlName="indicadorRenovable"></p-checkbox>
                </div>
                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_RESPALDO' | translate}}" binary="true"
                              id="idManejaGarantia"
                              name="nomManejaGarantia"
                              formControlName="indicadorManejaGarantia"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_RESTRICCIONES' | translate}}" binary="true"
                              id="idRestricciones"
                              name="nomRestricciones"
                              formControlName="indicadorRestricciones"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_VOLUNTADPAGO' | translate}}" binary="true"
                              id="idVoluntadPago"
                              name="nomVoluntadPago"
                              formControlName="indicadorVoluntadPago"></p-checkbox>
                </div>

                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_CICLOINTERNO' | translate}}" binary="true"
                              id="indicadorCicloInterno"
                              name="nomIndicadorCicloInterno"
                              formControlName="indicadorCicloInterno"></p-checkbox>
                </div>
                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_FLUJODIGITAL' | translate}}" binary="true"
                              id="indicadorFlujoDigital"
                              name="nomIndicadorFlujoDigital"
                              (onChange)="cambioEstadoCampos($event)"
                              formControlName="indicadorFlujoDigital"></p-checkbox>
                </div>
                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox label="{{ 'PRODUCTO.LBL_PERIODOGRACIA' | translate}}" binary="true"
                              id="indicadorPeriodoGracia"
                              name="indicadorPeriodoGracia"
                              formControlName="indicadorPeriodoGracia"></p-checkbox>
                </div>
                <div class="col-12 md:col-4 lg:col-4">
                  <p-checkbox
                    label="{{ 'PRODUCTO_ADJUNTO.LBL_TITULO' | translate}}"
                    id="indicadorAplicaAdjunto"
                    name="indicadorAplicaAdjunto"
                    formControlName="indicadorAplicaAdjunto"
                    [binary]="true">
                  </p-checkbox>
                </div>
              </div>
              <div class="grid form-footer-buttons">
                <div class="form-group col-12">
                  <div *ngIf="!guardando">
                    <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                    <button icon="fa fa-plus" label="{{( f.idProducto.value ? 'BTN_ACTUALIZAR' : 'BTN_GUARDAR')  | translate }}"
                            type="submit"
                            pButton></button>
                  </div>
                  <div *ngIf="guardando">
                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                    <span>{{'LBL_GUARDANDO' | translate }}</span>
                  </div>
                </div>
              </div>
            </form>
          </p-accordionTab>
         <p-accordionTab *ngIf="producto && producto.indicadorPeriodoGracia" header="{{ 'PRODUCTO.LBL_PERIODOGRACIA' | translate }}"
                         [selected]="tabSeleccionado === 'PERIODOGRACIA'"
                         [disabled]="codeTipoProductoBancario == codigosProducto.PASARELA">
           <div class="grid form-group">
             <div class="col-12 lg:col-12 md:col-12">
               <p-tabView [activeIndex]="tabViewIndex" (onChange)="cambiarTabOnClick( $event )">
                 <p-tabPanel header="{{ 'PRODUCTO.LBL_PERIODOGRACIA' | translate }}" [selected]="tabViewIndex === 0">
                 <form [formGroup]="formularioPeriodoGracia" *ngIf="formularioPeriodoGracia" (ngSubmit)="onSubmitPeriodoGracia()" novalidate id="formularioPeriodoGracia" name="formularioPeriodoGracia">
                   <div class="grid form-group">
                     <div class="col-3 md:col-3 lg:col-3">
                       <div class="div-form">
                         <p-checkbox label="{{ 'PRODUCTO.LBL_OPCIONAL' | translate}}" binary="true"
                                     id="indicadorOpcional"
                                     name="indicadorOpcional"
                                     (onChange)="cambiarEstadovalorMinimo($event)"
                                     formControlName="indicadorOpcional"></p-checkbox>
                       </div>
                     </div>
                     <div class="col-3 md:col-3 lg:col-3">
                       <div class="div-form">
                         <label for="plazoMinimo"> {{ 'PRODUCTO.LBL_VALORPERIODOMINIMO' | translate}}</label>
                         <input type="text" pInputText class="form-control" maxlength="3"
                                id="plazoMinimo"
                                name="plazoMinimo"
                                (blur)="validarMaximo()"
                                [readOnly]="estadoValorMinimo"
                                formControlName="plazoMinimo"
                                numero-entero-reactive/>
                       </div>
                     </div>
                     <div class="col-3 md:col-3 lg:col-3">
                       <div class="div-form">
                         <label for="plazoMaximo"> *{{ 'PRODUCTO.LBL_VALORPERIODOMAXIMO' | translate}}</label>
                         <input type="text" pInputText class="form-control" maxlength="3"
                                id="plazoMaximo"
                                name="plazoMaximo"
                                (blur)="validarMaximo()"
                                formControlName="plazoMaximo"
                                numero-entero-reactive/>
                         <div class="p-message p-messages-error p-corner-all"
                              *ngIf="submitted && !pg.plazoMaximo.valid">
                           <i class="fa fa-close"></i>
                           {{ 'PRODUCTO.LBL_VALORPERIODOMAXIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                         </div>
                       </div>
                     </div>
                     <div class="col-3 md:col-3 lg:col-3">
                       <div class="div-form">
                         <label for="idTipoPeriodoGracia"> *{{ 'PRODUCTO.LBL_TIPOPERIODO' | translate}}</label>
                         <p-dropdown disableTab  id="idTipoPeriodoGracia" name="idTipoPeriodoGracia" placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                                     [options]="listaTipoPeriodo"
                                     formControlName="idTipoPeriodoGracia"
                         ></p-dropdown>
                         <div class="p-message p-messages-error p-corner-all"
                              *ngIf="submitted && !pg.idTipoPeriodoGracia.valid">
                           <i class="fa fa-close"></i>
                           {{ 'PRODUCTO.LBL_TIPOPERIODO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                         </div>
                       </div>
                     </div>
                   </div>
                   <div class="grid">
                     <div class="col-4 md:col-4 lg:col-4">
                       <div class="div-form">
                         <p-checkbox label="{{ 'PRODUCTO.LBL_INTERESES' | translate}}" binary="true"
                                     id="indicadorIntereses"
                                     name="indicadorIntereses"
                                     formControlName="indicadorIntereses"></p-checkbox>
                       </div>
                     </div>
                     <div class="col-4 md:col-4 lg:col-4">
                       <div class="div-form">
                         <p-checkbox label="{{ 'PRODUCTO.LBL_CAPITAL' | translate}}" binary="true"
                                     id="indicadorCapital"
                                     name="indicadorCapital"
                                     formControlName="indicadorCapital"></p-checkbox>
                       </div>
                     </div>
                     <div class="col-4 md:col-4 lg:col-4">
                       <div class="div-form">
                         <p-checkbox label="{{ 'PRODUCTO.LBL_OTROSCONCEPTOS' | translate}}" binary="true"
                                     id="indicadorOtrosConceptos"
                                     name="indicadorOtrosConceptos"
                                     (onChange)="estadoAgregarConceptos($event)"
                                     formControlName="indicadorOtrosConceptos"></p-checkbox>
                       </div>
                     </div>
                   </div>
                   <div class="grid form-footer-buttons">
                     <div class="form-group col-12">
                       <div *ngIf="!guardando">
                         <a (click)="regresar(formularioPeriodoGracia.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                         <button icon="fa fa-plus" label="{{( pg.idProductoPeriodoGracia.value ? 'BTN_ACTUALIZAR' : 'BTN_GUARDAR')  | translate }}"
                                 type="submit"
                                 pButton></button>
                       </div>
                       <div *ngIf="guardando">
                         <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                         <span>{{'LBL_GUARDANDO' | translate }}</span>
                       </div>
                     </div>
                   </div>
                 </form>
                 </p-tabPanel>
                 <p-tabPanel   header="{{ 'PRODUCTO.LBL_OTROSCONCEPTOS' | translate }}" *ngIf="productosPeriodosGracias  && productosPeriodosGracias.idProductoPeriodoGracia && productosPeriodosGracias.indicadorOtrosConceptos" [selected]="tabViewIndex === 1">
                   <div class="grid">
                     <div class="col-12 md:col-12 lg:col-12">
                       <form [formGroup]="formularioConceptos" (ngSubmit)="onSubmitConceptos()" novalidate id="formularioConceptos" name="formularioConceptos">
                       <div class="grid form-group">
                         <div class="col-6 md:col-6 lg:col-6">
                          <div class="div-form">
                            <label> {{ 'PRODUCTO.LBL_CONCEPTOS' | translate}}</label>
                            <p-multiSelect id="tecnico" name="tecnico" [options]="listaConceptos"
                                           [panelStyle]="{minWidth:'100%'}"
                                           [style]="{width: '100%'}"
                                           selectedItemsLabel="{0} items seleccionados"
                                           maxSelectedLabels="0"
                                           defaultLabel="{{'LBL_SELECCIONE' | translate}}"
                                           formControlName="conceptos" [filter]="true"
                                           required="true"
                                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                           optionValue="value"
                                           optionLabel="label"
                            ></p-multiSelect>
                            <div class="p-message p-messages-error p-corner-all"
                                 *ngIf="submitted && !c.conceptos.valid">
                              <i class="fa fa-close"></i>
                              {{ 'PRODUCTO.LBL_CONCEPTOS' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                            </div>
                          </div>
                         </div>
                         <div class="col-6 md:col-6 lg:col-6">
                           <button type="submit" pButton icon="fa fa-plus"
                                   label="{{ 'BTN_AGREGAR' | translate}}"></button>
                         </div>
                       </div>
                       </form>
                       <p-table [value]="listaConceptosAsignados" #dt [columns]="columnas"
                                [paginator]="true" [rows]="10"
                                 [loading]="loadingConceptos">
                         <ng-template pTemplate="header" let-columns>
                           <tr>
                             <th *ngFor="let col of columnas" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                                 class="text-center">
                               {{col.header | translate}}
                               <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>

                             </th>
                           </tr>
                         </ng-template>

                         <ng-template pTemplate="body" let-row>
                           <tr>
                             <td class="text-center">{{row.idConceptoFacturacion}}</td>
                             <td class="text-center">{{row.nombreItemConceptos}}</td>
                             <td class="text-center">
                               <div class="btn-group" role="group">
                                 <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                                         title="{{'BTN_ELIMINAR' | translate}}"
                                         pButton (click)="deshabilitarConceptos(row)"></button>

                               </div>
                             </td>
                           </tr>
                         </ng-template>
                         <ng-template pTemplate="emptymessage" let-columns>
                           <tr>
                             <td [attr.colspan]="columns.length" class="text-center">
                               {{ 'MSG_NOHAYREGISTROS' | translate}}
                             </td>
                           </tr>
                         </ng-template>
                       </p-table>
                     </div>
                   </div>
                 </p-tabPanel>
               </p-tabView>
             </div>
           </div>
         </p-accordionTab>
       </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="producto && producto.idProducto">
        <div class="form-group col-12">
          <div *ngIf="!habProducto">
            <button icon="fa fa-plus"
                    label="{{ (producto.indicadorHabilitado ? 'PRODUCTO.BTN_INHABILITARPRODUCTO' : 'PRODUCTO.BTN_HABILITARPRODUCTO')  | translate }}"
                    type="button" (click)="habilitarProducto(!producto.indicadorHabilitado)"
                    pButton></button>
          </div>
          <div *ngIf="habProducto">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_CONSULTANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_ALERTAS' | translate}}" [disabled]="!producto"
                *ngIf=" ( !producto || producto.indicadorAlertas)">

      <app-producto-politica-alerta [producto]="producto" [verDetalle]="false"
                                    *ngIf="producto && producto.idProducto && lisTabCargados.alerta"></app-producto-politica-alerta>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_AUTORIZACIONES' | translate}}" [disabled]="(!producto) || (codeTipoProductoBancario == codigosProducto.AHORRO && codeTipoCuentaAhorro !== tiposCuentaAhorro.AHORRO_PROGRAMADO)" >
      <app-producto-autorizacion [producto]="producto"
                                 *ngIf="producto && producto.idProducto && lisTabCargados.autorizacion"></app-producto-autorizacion>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_CAMPOSDIGITAL' | translate}}" [disabled]="!producto" *ngIf="!producto || producto.indicadorFlujoDigital">
      <app-flujos-creditos-digitales [producto]="producto" [flujoDigital]="canales.PRODUCTO"
                                     *ngIf="producto && producto.idProducto && lisTabCargados.camposDigitales"></app-flujos-creditos-digitales>
    </p-tabPanel>
    <p-tabPanel *ngIf="codeTipoProductoBancario == codigosProducto.INVERSION"
                header="{{ 'PRODUCTO.LBL_MONTOS_TASAS' | translate}}"
                [disabled]="!producto">
      <app-producto-montos-tasas [producto]="producto"></app-producto-montos-tasas>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_CONFIRVINCU' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto || producto.indicadorConfirmacionVinculacion">
      <app-producto-confirmacion-vinculacion [producto]="producto"
                                             *ngIf="producto && producto.idProducto && lisTabCargados.confirmacionVincualcion"></app-producto-confirmacion-vinculacion>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_CONTROLES' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION">
      <app-producto-control [producto]="producto" [aliado]="false"
                            *ngIf="producto && producto.idProducto && lisTabCargados.controlAnalizamos"></app-producto-control>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_CUESTIONARIOS' | translate}}" [disabled]="!producto && codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto || producto.indicadorCuestionario">
      <app-producto-cuestionario [producto]="producto"
                                 *ngIf="producto && producto.idProducto && lisTabCargados.cuestionarios"></app-producto-cuestionario>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_DESEMBOLSO' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto || producto.indicadorDesembolso">
      <app-producto-desembolso-listado [producto]="producto"
                                       *ngIf="producto && producto.idProducto && lisTabCargados.desembolso"></app-producto-desembolso-listado>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_DESTINO' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto || (!producto.indicadorMontoDestino && !producto.indicadorMontoDestinoPerfil)">
      <app-producto-destino [producto]="producto"
                            *ngIf="producto && producto.idProducto && lisTabCargados.destino"></app-producto-destino>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_ESTADOS' | translate}}" [disabled]="!producto">
      <app-producto-estado-aliado [producto]="producto" [aliado]="false"
                                  *ngIf="producto && producto.idProducto && lisTabCargados.estado"></app-producto-estado-aliado>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_FRECUENCIAS' | translate}}" [disabled]="!producto ">
      <app-producto-frecuencia [producto]="producto"
                               *ngIf="producto && producto.idProducto && lisTabCargados.frecuencias"></app-producto-frecuencia>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTOFLUJOVENTA.LBL_FLUJOVENTA' | translate}}" [disabled]="(!producto) ">
      <app-producto-flujo-venta-paso [producto]="producto" [listaTiposPersonas]="listasTiposPersonas"
                                      *ngIf="producto && producto.idProducto && lisTabCargados.flujoVentaPaso"></app-producto-flujo-venta-paso>
    </p-tabPanel>


    <p-tabPanel header="{{ 'PRODUCTO.LBL_HOJAEVALUACIONES' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO  || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto || producto.indicadorHojaEvaluacion">
      <app-producto-hoja-evaluacion [producto]="producto"
                                    *ngIf="producto && producto.idProducto && lisTabCargados.hojaEvaluacion"></app-producto-hoja-evaluacion>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_MONTOS' | translate}}" [disabled]="(!producto) || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto?.indicadorMontoDestino && !producto?.indicadorMontoDestinoPerfil">
      <app-producto-monto [producto]="producto"
                          *ngIf="producto && producto.idProducto && lisTabCargados.monto"></app-producto-monto>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_MONTOALIADO' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION || codeTipoProductoBancario == codigosProducto.PASARELA"
                *ngIf="!producto || producto.indicadorMontoDestinoPerfil">
      <app-producto-monto-aliado [producto]="producto"
                                 *ngIf="producto && producto.idProducto && lisTabCargados.montoAliado"></app-producto-monto-aliado>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_MONTOPORDESTINO' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION || codeTipoProductoBancario == codigosProducto.PASARELA"
                *ngIf="!producto || (producto?.indicadorMontoDestino)">
      <app-producto-destino-monto [producto]="producto"
                                  *ngIf="producto && producto.idProducto && lisTabCargados.montodestino"></app-producto-destino-monto>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_PLANESCARGOS' | translate}}" [disabled]="(!producto) || codeTipoProductoBancario == codigosProducto.AHORRO" >
      <app-producto-planes-cargos [producto]="producto"
                                  *ngIf="producto && producto.idProducto && lisTabCargados.plancargo"></app-producto-planes-cargos>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_PRODSEGUANAL' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO">
      <app-producto-seguro-analizamos [producto]="producto"
                                      *ngIf="producto && producto.idProducto && lisTabCargados.seguroAnalizamos"></app-producto-seguro-analizamos>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_REFERENCIAS' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO">
      <app-producto-referencia [producto]="producto" [listaTiposPersonas]="listasTiposPersonas"
                               *ngIf="producto && producto.idProducto && lisTabCargados.referencia"></app-producto-referencia>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_RENOVACION' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto || producto.indicadorRenovable">
      <app-producto-renovacion [producto]="producto"
                               *ngIf="producto && producto.idProducto && lisTabCargados.renovacion"></app-producto-renovacion>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_RESPALDO' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto || producto.indicadorManejaGarantia">
      <app-producto-garantia [producto]="producto" (setearValoresProducto)="setearValoresProducto($event)"
                             *ngIf="producto && producto.idProducto && lisTabCargados.garantias"></app-producto-garantia>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_RESTRICCIONES' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO"
                *ngIf="!producto || producto.indicadorRestricciones">
      <app-producto-restriccion [producto]="producto"
                                *ngIf="producto && producto.idProducto && lisTabCargados.restricciones "></app-producto-restriccion>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_VOLUNTADPAGO' | translate}}" [disabled]="!producto || codeTipoProductoBancario == codigosProducto.AHORRO  || codeTipoProductoBancario == codigosProducto.INVERSION"
                *ngIf="!producto || producto.indicadorVoluntadPago">
      <app-producto-voluntad-pago [producto]="producto"
                                  *ngIf="producto && producto.idProducto && lisTabCargados.voluntadPago"></app-producto-voluntad-pago>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTOCATEGORIAS.LBL_CATEGORIAS' | translate}}"
                [disabled]="!producto"
                *ngIf="codeTipoCuentaAhorro === tiposCuentaAhorro.AHORRO_PROGRAMADO">
      <app-producto-categorias [producto]="producto"
                               *ngIf="producto && producto.idProducto"></app-producto-categorias>
    </p-tabPanel>
    <p-tabPanel header="{{'GARANTIAPRODUCTOS.LBL_TITULO' | translate}}">
      <app-producto-garantia-idonea [producto]="producto">

      </app-producto-garantia-idonea>
    </p-tabPanel>
    <p-tabPanel header="{{'PRODUCTO_PASARELA.LBL_TITULO' | translate}}" *ngIf="codeTipoProductoBancario == codigosProducto.PASARELA" [disabled]="!producto?.idProducto">
      <app-producto-pasarela *ngIf="producto?.idProducto" [producto]="producto"></app-producto-pasarela>
    </p-tabPanel>
    <p-tabPanel header="{{'PRODUCTO_ADJUNTO.LBL_TITULO' | translate}}" *ngIf="producto?.idProducto && producto.indicadorAplicaAdjunto" [disabled]="codeTipoProductoBancario != codigosProducto.PASARELA">
      <app-producto-adjuntos *ngIf="codeTipoProductoBancario == codigosProducto.PASARELA" [producto]="producto"></app-producto-adjuntos>
    </p-tabPanel>
  </p-tabView>
  <div class="grid form-footer-buttons" *ngIf="producto && producto.idProducto">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="submit" (click)="regresar(false)"
              pButton></button>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="identificacion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

